import { createAction, props } from '@ngrx/store';
import { ClubLogs } from './club-logs.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records club log',
    props<{ clubId: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records club log success', 
    props<{ listData: ClubLogs[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records club log failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state club log',
);
